module.exports = __webpack_public_path__ + "img/img-1.272be075.webp";